import { BaseMapper } from '@ps/utils';
import { CompanyDto } from '../dtos/company.dto';
import { Company } from '../../models/company.model';

export class CompanyMapper extends BaseMapper<CompanyDto, Company> {
  public fromDto({ id, name }: CompanyDto): Company {
    return { id, name };
  }
}
